<template>
  <q-layout class="theme-1" view="hHh lpr lFr">
    <Header v-if="isUserLogged && isChangePassWord" @collapseToggle="leftDrawerOpen = !leftDrawerOpen" />

    <q-drawer class="bg-none tw-side-nav" show-if-above v-if="isUserLogged && isChangePassWord" v-model="leftDrawerOpen"
      side="left" :width="240">
      <Sidebar v-on:closeDrawer="closeTheDrawer($event)" />
      <div class="tw-app-version-wrapper tw-app-version-side-bar w-100" v-if="isUserLogged && isChangePassWord">
        <span class="d-block font-size-11 text-primary text-right w-100">{{
          appVersion
          }}</span>
      </div>
    </q-drawer>

    <q-page-container class="pr-5">
      <confirmation-dialog :show="showConfirmationDialog" />
      <confirmation-delete-dialog :show="showConfirmationDeleteDialog" />
      <router-view />
    </q-page-container>

    <div class="tw-aside-tools">
      <div class="tw-aside-tools-wrapper"> 
        <div v-if="getsimulationPanelStatusFromRoute.status" class="z-top">
          <SummaryPanel  v-if=" !isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary' && getsummaryAvailable" />
          <OrderSummaryPanel v-if=" isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary'" />
        </div>
        <div class="mt-2">
          <div v-if="isUserLogged && isChangePassWord" class="tw-message-drawer">
            <Communication />
           <!-- <ControlsButton /> -->
            <PrintDocumentButton v-if=" !isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary' && getsummaryAvailable"  />
           <!-- <AlertButton
              v-if="
              isTaskModuleOrder && getsimulationPanelStatusFromRoute.type === 'summary' && getsimulationPanelStatusFromRoute.status" />-->
          </div> 
        </div>

        <!-- <div v-if="getsimulationPanelStatusFromRoute.type === 'simulation'">
          <button v-if="!showSummary" @click="openSummary" class="btn btn-success">
            <span class="svg-icon">
              <svg
                width="25"
                height="28"
                viewBox="0 0 25 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.40094 3.4401V2.10677C7.40033 1.76658 7.52977 1.43903 7.76277 1.19116C7.99577 0.943285 8.3147 0.793848 8.65427 0.773438H16.0009C16.3381 0.797099 16.6538 0.947953 16.884 1.19548C17.1142 1.44301 17.2418 1.76874 17.2409 2.10677V3.4401C17.2418 3.77813 17.1142 4.10386 16.884 4.35139C16.6538 4.59892 16.3381 4.74978 16.0009 4.77344H8.65427C8.3147 4.75303 7.99577 4.60359 7.76277 4.35572C7.52977 4.10785 7.40033 3.78029 7.40094 3.4401ZM24.0009 10.3068V19.9334C24.0168 20.8755 23.847 21.8114 23.5011 22.6878C23.1552 23.5642 22.6401 24.3639 21.9851 25.0412C21.3301 25.7185 20.5481 26.2601 19.6837 26.6351C18.8194 27.0101 17.8897 27.2111 16.9476 27.2268H7.08094C5.18074 27.2022 3.36795 26.4246 2.04054 25.0646C0.713134 23.7047 -0.0204132 21.8737 0.000939745 19.9734V10.3468C-0.0270515 8.61371 0.571086 6.92871 1.68552 5.60118C2.79996 4.27366 4.35589 3.39271 6.06761 3.1201V3.4401C6.06729 4.1337 6.33724 4.80013 6.82016 5.29799C7.30309 5.79585 7.96099 6.08596 8.65427 6.10677H16.0009C16.6919 6.08257 17.3464 5.79097 17.8265 5.29348C18.3066 4.79598 18.5747 4.13147 18.5743 3.4401V3.21344C20.1405 3.62092 21.5255 4.54049 22.5088 5.82584C23.4921 7.1112 24.0174 8.68849 24.0009 10.3068ZM7.80094 15.4134L10.9743 19.3334C11.0666 19.4457 11.1826 19.5362 11.314 19.5985C11.4454 19.6607 11.5889 19.6931 11.7343 19.6934C11.8856 19.6924 12.0345 19.6557 12.1689 19.5861C12.3033 19.5166 12.4193 19.4163 12.5076 19.2934L16.8543 13.4401C16.9828 13.2317 17.0357 12.9855 17.0041 12.7427C16.9726 12.4999 16.8585 12.2754 16.6809 12.1068C16.4748 11.9647 16.2224 11.9064 15.9748 11.9435C15.7272 11.9806 15.503 12.1105 15.3476 12.3068L11.7476 17.1468L9.33427 14.1601C9.17326 13.9701 8.94633 13.8479 8.69903 13.8183C8.45172 13.7886 8.20234 13.8536 8.00094 14.0001C7.79628 14.1676 7.66209 14.4059 7.62504 14.6677C7.58799 14.9296 7.65078 15.1958 7.80094 15.4134Z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>

            <label class="tw-vertical-button-text"> Récapitulatif de l'offre </label>
          </button>
          <div v-if="showSummary" class="tw-aside-tools-inner">
            <DemandSimulationSummary :isOpen="true" />
          </div>
        </div> -->
      </div>
           <q-btn icon="keyboard_arrow_up" color="primary" @click="scrollToTop"  v-if="!isLoginPage"
        style="position: fixed; bottom: 20px; right: 3px; background: #3490dc; color: white; border: none; padding: 10px 15px; border-radius: 5px; cursor: pointer;"/>
    </div>

    <!--    <q-ajax-bar-->
    <!--        ref="bar"-->
    <!--        position="top"-->
    <!--        color="green"-->
    <!--        size="5px"-->
    <!--    />-->

    <div class="tw-global-spinner-wrapper" v-if="isLoading">
      <CapitoleLoader />
    </div>

  </q-layout>
</template>

<script>
import { logger } from "@/utils/logger";
import { computed, ref } from "vue";
import Header from "@/components/layout/Header";
import Sidebar from "@/components/layout/Sidebar";
import Communication from "@/components/layout/Communication.vue";
import store from "@/store";
import ConfirmationDialog from "@/components/general/ConfirmationDialog";
import ConfirmationDeleteDialog from "@/components/general/ConfirmationDeleteDialog.vue";
import { useRoute } from "vue-router";
import { globalConfig } from "@/utils";
import { mapGetters } from "vuex";
import SummaryPanel from "@/components/summary-panel/SummaryPanel.vue";
import DemandSimulationSummary from "@/components/demand/simulation/DemandSimulationSummary.vue";
import ControlsButton from "@/components/controls/ControlsButton.vue";
import OrderSummaryPanel from "@/components/summary-panel/order/OrderSummaryPanel.vue";
import PrintDocumentButton from "@/components/document/PrintDocumentButton.vue";
import AlertButton from "@/components/alert/AlertButton.vue";
import FilterList from "@/components/filter/FilterList.vue";
import CapitoleLoader from "@/components/general/CapitoleLoader.vue";
import { settings } from "@/settings";

export default {
  components: {
    CapitoleLoader,
    OrderSummaryPanel,
    Header,
    Sidebar,
    Communication,
    ConfirmationDialog,
    SummaryPanel,
    DemandSimulationSummary,
    ConfirmationDeleteDialog,
    ControlsButton,
    PrintDocumentButton,
    FilterList,
    AlertButton
  },
  setup() {
    store.subscribe((mutation, state) => {
      const thirdUpdateMutations = [
        "thirdModule/setThirdSelected",
        "demandModule/editOffer",
        "simulationModule/initSimulation",
        "authModule/setUser",
      ];
      if (thirdUpdateMutations.indexOf(mutation.type) !== -1) {
        switch (mutation.type) {
          case "thirdModule/setThirdSelected":
            localStorage.setItem(
              globalConfig.storageKeys.thirdModule,
              JSON.stringify(state.thirdModule)
            );
            break;
          case "demandModule/editOffer":
            localStorage.setItem(
              globalConfig.storageKeys.demandModule,
              JSON.stringify(state.demandModule)
            );
            break;
          case "simulationModule/initSimulation":
            localStorage.setItem(
              globalConfig.storageKeys.simulationModule,
              JSON.stringify(state.simulationModule)
            );
            break;
          case "authModule/setUser":
            localStorage.setItem(
              globalConfig.storageKeys.authModule,
              JSON.stringify(state.authModule)
            );
            break;
        }
      }
    });
    const drawerRightWidth = ref(20);

    const bar = ref(null);
    const leftDrawerOpen = ref(false);
    const rightDrawerOpen = ref(true);

    const route = useRoute();
    const currentRoute = computed(() => route?.name ?? null);

    const appVersion = `${settings.appVersion}`;

    return {
      leftDrawerOpen,
      rightDrawerOpen,
      currentRoute,
      bar,
      drawerRightWidth,
      appVersion,
    };
  },
  computed: {
    getsummaryAvailable() {
      return store.state.summaryAvailable;
    },

    isTaskModuleOrder() {
      return store.getters["taskModule/isTaskModuleOrder"];
    },
    isTaskAnalysis() {
    return store.getters["taskModule/isTaskAnalysis"];
   },
    getsimulationPanelStatusFromRoute() {
      const routeName = this.currentRoute;

      let status = false;
      let type = null;
      let showPrintDocument = false;

      switch (routeName) {
        case "mo-demand-detail": {
          status = true;

          if (
              this.$store.state.middleOfficeModule.offer &&
              this.$store.state.middleOfficeModule.offer.generatedDocuments &&
              this.$store.state.middleOfficeModule.offer.generatedDocuments.length > 0
          ) {
            showPrintDocument = true;
          }

          if (this.$store.state.middleOfficeModule.offer) {
            type = "summary";
          } else {
            type = "simulation";
          }
          break;
        }

        case "demand-edit": {
          if (this.$store.state.demandModule?.offer?.resourceUid) {
            status = true;
            showPrintDocument = true;
          } else {
            status = false;
            showPrintDocument = false;
          }

          type = "summary";
          break;
        }

        case "order-edit": {
          if (this.$store.state.orderModule?.order?.resourceUid) {
            status = true;
            showPrintDocument = true;
          } else {
            status = false;
            showPrintDocument = false;
          }

          type = "summary";
          break;
        }

        case "TaskDetail": {
          status = true;
          type = "summary";
          showPrintDocument = true;
          break;
        }

        case "third-edit": {
          showPrintDocument = true;
          break;
        }

        default: {
          status = false;
          type = null;
          showPrintDocument = false;
          break;
        }
      }
      return { status, type, showPrintDocument };
    },

    showConfirmationDialog() {
      return (
        store.state.confirmationDialogState && store.state.confirmationDialogState.show
      );
    },
    isUserLogged() {
      return !!(store.state.authModule.user && store.state.authModule.user.loggedIn);
    },
    isChangePassWord() {
      return store.state.authModule.changePassworIn;
    },
    showConfirmationDeleteDialog() {
      return (
        store.state.confirmationDeleteDialogState &&
        store.state.confirmationDeleteDialogState.show
      );
    },

    isLoading() {
      return store.state.isLoading
    },
    isLoginPage() {
  return this.currentRoute === 'login';
}
  },
  watch: {
    currentRoute(to) {
      // logger.debug("ROUTE CHANGED:", to);
    }
  },
  created() {
    // logger.debug("APP CREATED - route:", this.currentRoute);
    store.state.isLoading = false
    this.applyTheme(settings.theme)
    store.dispatch("authModule/initializeAuth");
  },
  methods: {
    applyTheme(theme) {
      const themeObj = JSON.parse(theme)
      for (const [key, value] of Object.entries(themeObj)) {
        document.documentElement.style.setProperty(key, value);
      }
    },
    openSummary() {
      store.state.middleOfficeModule.showSummary = !store.state.middleOfficeModule
        .showSummary;
    },
    closeTheDrawer(leftDrawerOpen) {
      this.leftDrawerOpen = !leftDrawerOpen;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>
